import React from 'react';
import { Grid } from 'twain-sport-fe-mono/components/Grid';
import { TwainGameId } from 'betgames-contract-js';
import { useParticipantsStatisticsPair } from 'twain-sport-fe-mono/hooks';
import { translationProvider } from 'twain-sport-fe-mono/store/translations';
import { IParticipantsPair } from 'twain-sport-fe-mono/interfaces';
import { ResultsDirection } from './StatisticsResult/enums/ResultsDirection';
import { StatisticsResult } from './StatisticsResult';
import classes from './LastStatistics.module.scss';

interface IProps {
    participants: IParticipantsPair;
    gameId?: TwainGameId;
}

export const LastStatistics: React.FC<IProps> = (props) => {
    const statistics = useParticipantsStatisticsPair(props.participants);

    return (
        <div className={classes.container}>
            <div className={classes.resultsCase}>
                <div className={classes.title} data-qa="title-lastStatistics-lastGames">
                    {translationProvider.string('last_5_games')}
                </div>
                <div className={classes.results}>
                    <StatisticsResult
                        results={props.participants.left?.lastResults}
                        direction={ResultsDirection.TO_LEFT}
                    />
                    <StatisticsResult
                        results={props.participants.right?.lastResults}
                        direction={ResultsDirection.TO_RIGHT}
                    />
                </div>
            </div>
            <Grid statistics={statistics} gameId={props.gameId} />
        </div>
    );
};
